import React from 'react';
import PropTypes from 'prop-types';
import ReactionAdditionalDataCellComponent from '@Components/Results/reactions/reaction-details/additional-data/reaction-additional-data-cell.component';
import ReactTableColumnSwitcherHelper from '@Components/Results/services/react-table-columns-switcher-helper.service';
import StickyTableHeaderComponent from '@Components/Results/sticky-table-header.component';

function ReactionAdditionalDataContents({ formatedData, uniqueId, databaseId, showAllNonEmptyCols }) {
  return (
    <table
      className={`rx-table rx-table--additional-info sticky-table-header ${ReactTableColumnSwitcherHelper.getTableClass(
        uniqueId,
        formatedData?.headers
      )}`}>
      <StickyTableHeaderComponent headers={formatedData?.headers} showAllNonEmptyCols={showAllNonEmptyCols} />
      <tbody>
        {formatedData?.rows?.map((row, rI) => (
          <tr key={row.id || rI}>
            {formatedData?.headers?.map((cell, i) => (
              <ReactionAdditionalDataCellComponent key={cell.id || i} row={row} cell={cell} index={i} databaseId={databaseId} />
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

ReactionAdditionalDataContents.propTypes = {
  formatedData: PropTypes.object.isRequired,
  uniqueId: PropTypes.string.isRequired,
  databaseId: PropTypes.string.isRequired,
  showAllNonEmptyCols: PropTypes.bool,
};

export default ReactionAdditionalDataContents;
